import { useAuth } from '@/contexts/AuthContext'
import ActivitySidebar from '@/components/ActivitySidebar'
import ThreadsFromMyGroups from '@/components/ThreadsFromMyGroups'
import LatestThreads from '@/components/LatestThreads'

export default function Activity() {
  const { user } = useAuth()

  if (!user) {
    return (
      <div className="max-w-6xl mx-auto">
        <p style={{ color: 'var(--text-primary)' }}>
          Please log in to view activity.
        </p>
      </div>
    )
  }

  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-6">
        <h1 
          className="text-3xl font-bold mb-2"
          style={{ color: 'var(--text-primary)' }}
        >
          Activity
        </h1>
        <p 
          className="text-lg"
          style={{ color: 'var(--text-primary)' }}
        >
          Recent activity from your groups and across the community
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Left Sidebar */}
        <div className="lg:col-span-1">
          <ActivitySidebar userId={user.id} />
        </div>

        {/* Main Content */}
        <div className="lg:col-span-3 space-y-6">
          <ThreadsFromMyGroups userId={user.id} />
          <LatestThreads userId={user.id} />
        </div>
      </div>
    </div>
  )
}

